import { apiRequest, withToken } from './http-client';

export const getTenantAuditLogs = async (token, params = {}) => {
    return apiRequest({
        method: 'get',
        url: '/tenant-audit-log/',
        headers: withToken(token),
        params,
    }, 'No se pudo obtener el historial de auditoría.');
};

export const getTenantAuditLogById = async (token, auditLogId) => {
    return apiRequest({
        method: 'get',
        url: `/tenant-audit-log/${auditLogId}`,
        headers: withToken(token),
    }, 'No se pudo obtener el detalle del registro de auditoría.');
};